import './index_mWeb.css';
import Card from '../card';
import { convertToDollars, RoundedOffAmount } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import Text from '../text';
import moment from 'moment';
import React from 'react';

interface Props {
  item: any;
  decimalFactor?: any;
  currencyType?: any;
  creditType: any;
}

const TransactionEarningItemMWeb = ({ item, creditType }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const { amount = 0, createdOn = '', transactionType = '', matchTitle = null } = item;

  const newAmount = RoundedOffAmount(amount);

  const statusColor =
    transactionType === 'debit' ? theme.transactionDebit : theme.transactionCredit;

  const surfaceColor = {
    backgroundColor: '#202a38',
    boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.16)',
    borderRadius: '4px'
  };

  const simpleTextColor = {
    color: theme.transactionDateTime
  };

  return (
    <Card className={'transaction-earn-item-container__mWeb'} style={surfaceColor}>
      <View
        className={'transaction-earn-item-header'}
        style={{ borderLeft: `8px solid ${statusColor}` }}>
        <View className={'transaction-earn-item-left-part'}>
          <Text
            className={'transaction-earn-item-header-text__mWeb'}
            style={{
              fontFamily: 'Poppins',
              color: statusColor
            }}>
            {`${creditType}`}
          </Text>

          <Text className={'transaction-earn-item-simple-text__mWeb'} style={simpleTextColor}>
            {moment(new Date(createdOn), 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')}
          </Text>
          {matchTitle && (
            <Text
              className={'transaction-earn-item-content-text'}
              style={simpleTextColor}>{`Match Name : ${matchTitle}`}</Text>
          )}
        </View>
        <View className={'transaction-earn-item-rightPart'}>
          <Text
            className={'transaction-earn-item-amount-text__mWeb'}
            style={{ color: statusColor }}>
            {`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}
          </Text>
        </View>
      </View>
    </Card>
  );
};
export default React.memo(TransactionEarningItemMWeb);
